import React from 'react'
import PropTypes from 'prop-types'
import { Dialog } from '@mui/material'
import { PanelHeader } from 'components/design-system/Panel'

/**
 * Modal (Figma 10:1892): Gradient/Surface + border/default + radius/md, padding 16, gap 16, Shadow/Card.
 * Header = Panel Header (title + nút close); `children` là Body slot. Độ rộng truyền qua `width`.
 */
const Modal = ({ open, onClose, title, action, width = 740, children, PaperProps, ...props }) => (
  <Dialog
    open={open}
    onClose={onClose}
    {...props}
    PaperProps={{
      ...PaperProps,
      sx: [
        {
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-16)',
          boxSizing: 'border-box',
          width,
          maxWidth: width,
          m: 'var(--space-16)',
          p: 'var(--space-16)',
          backgroundColor: 'transparent',
          backgroundImage: 'linear-gradient(to bottom, var(--color-navy-850), var(--color-navy-950))', // Gradient/Surface
          border: 'var(--stroke-default) solid var(--color-border-default)',
          borderRadius: 'var(--radius-md)',
          boxShadow: '4px 4px 16px 0 rgba(0, 0, 0, 0.3)' // Shadow/Card
        },
        ...(Array.isArray(PaperProps?.sx) ? PaperProps.sx : [PaperProps?.sx])
      ]
    }}
  >
    {(title || action || onClose) && <PanelHeader title={title} action={action} onClose={onClose} sx={{ px: 'var(--space-0)' }} />}
    {children}
  </Dialog>
)

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  title: PropTypes.node,
  action: PropTypes.node,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  PaperProps: PropTypes.object
}

export default Modal
